angular.module('picmonicpublic')
.controller('whyPicmonicController', ['$scope', '$anchorScroll', '$timeout', '$interval', function($scope, $anchorScroll, $timeout, $interval){
    $scope.openMarket = 'sketchy';
    $scope.selectedTweet = 0;

    var interval = $interval(function(){
        $scope.scrollTweets(1);
    }, 5000);

    this.$onDestroy = function(){
        $interval.cancel(interval);
    };

    $scope.scrollTweets = function(scroll) {
        $scope.selectedTweet = ($scope.selectedTweet + scroll + 6) % 6;
    };

    $scope.openSection = function(section) {
        if ($scope.openMarket && $scope.openMarket != section) {
            $timeout(function(){
                var offset = $anchorScroll.yOffset;
                offset = 64;
                $anchorScroll(section);
                $anchorScroll.yOffset = offset;
            }, 0);
        }
        $scope.openMarket = $scope.openMarket == section ? false : section;
    };
}]);